export default "__VITE_ASSET__BobOJcra__"